export enum ETipoArquivoFiscal {
    Sintegra = 1,
    SpedFiscal = 2,
    SpedPisCofins = 3,
}
